import React, { useEffect, useRef, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Card, CardHeader, CardBody } from "reactstrap";
import html2canvas from "html2canvas";
import { formatDateTime } from "../../../Components/Common/FormatDate";
import BillOrderProduct from "./BillOrderProduct";

const BillDownload = ({ isOpen, toggle, menuItem }) => {
  const billRef = useRef(null);
  const [userInfo, setUserInfo] = useState(null);

  // Fetch user info from localStorage on component mount
  useEffect(() => {
    const storedUserInfo = localStorage.getItem("user");
    if (storedUserInfo) {
      const parsedUserInfo = JSON.parse(storedUserInfo);
      setUserInfo(parsedUserInfo);
    }
  }, []);

  const handleDownload = () => {
    const billElement = billRef.current;

    if (billElement) {
      html2canvas(billElement, {
        scale: 3,
        useCORS: true,
        logging: true,
        allowTaint: true,
      }).then((canvas) => {
        const link = document.createElement("a");
        link.download = `bill-${menuItem?.orderRef}.png`;
        link.href = canvas.toDataURL("image/png", 1.0);
        link.click();
        toggle(); // Close the modal after download
      });
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="md">
      <ModalHeader toggle={toggle}>Download Invoice</ModalHeader>
      <ModalBody>
        <div ref={billRef}>
          <Card className="bill-style ">
            <CardHeader className="bill-header">
              <div className="text-center">
              {userInfo && (
                <>
                  <h4 className="m-0 p-0">{userInfo.organizationInfo.name}</h4>
                  <p className="m-0 p-0">{userInfo.organizationInfo.address1}</p>
                  <p className="m-0 p-0">Phone: {userInfo.user.phoneNumber}</p>
                </>
              )}
              </div>
              <hr />
              <div className="d-flex justify-content-between">
                <div>
                  <h5 className="mb-0">Bill No: #{menuItem?.orderRef}</h5>
                  <p className="mb-0">Date: {formatDateTime(menuItem?.createdDate)}</p>
                </div>
              </div>
            </CardHeader>
            <CardBody className="bill-body">
              <div className="table-responsive">
                <table className="table table-bordered mb-0">
                  {/* <thead>
                    <tr>
                      <th scope="col">Product</th>
                      <th scope="col">Price</th>
                      <th scope="col">Qty</th>
                      <th scope="col" className="text-end">Total</th>
                    </tr>
                  </thead> */}
                  <tbody>
                    <BillOrderProduct menuItem={menuItem} />
                  </tbody>
                </table>
              </div>
            </CardBody>
            <CardHeader className="bill-footer text-center">
              <p className="mb-0">Thank you for your business!</p>
              <p className="mb-0">Visit us again!</p>
            </CardHeader>
          </Card>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>Close</Button>
        <Button color="primary" onClick={handleDownload}>Download Invoice</Button>
      </ModalFooter>
    </Modal>
  );
};

export default BillDownload;